"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OUTLINE_WIDTH = exports.INSET_ELEMENT_DEFAULTS = exports.DISABLED_ICON_OFFSET = exports.BORDER_WIDTH = void 0;
var BORDER_WIDTH = 1;
exports.BORDER_WIDTH = BORDER_WIDTH;
var OUTLINE_WIDTH = 1;
exports.OUTLINE_WIDTH = OUTLINE_WIDTH;
var DISABLED_ICON_OFFSET = 24;
exports.DISABLED_ICON_OFFSET = DISABLED_ICON_OFFSET;
var INSET_ELEMENT_DEFAULTS = {
  width: 13,
  inset: 15
};
exports.INSET_ELEMENT_DEFAULTS = INSET_ELEMENT_DEFAULTS;